import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { View } from 'foundations-components/components/View';
import { WarningIcon } from 'foundations-assets/icons/components/WarningIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export const AbovePinnedViewLimitAlert = () => {
  return /*#__PURE__*/_jsx(Tooltip, {
    use: "longform",
    placement: "bottom",
    headingText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "viewsManagement.pinnedViews.abovePinnedViewLimit.title"
    }),
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "viewsManagement.pinnedViews.abovePinnedViewLimit.body"
    }),
    children: /*#__PURE__*/_jsx(View, {
      as: "span",
      display: "inline-block",
      paddingInlineEnd: "100",
      children: /*#__PURE__*/_jsx(WarningIcon, {
        alignWithText: true,
        size: "400",
        color: "fill-caution-default",
        "data-test-id": "pinned-views-limit-alert"
      })
    })
  });
};